import React from "react";

import { LanguageConstants } from "../../../constants/LanguageConstants";

export type QuotationItemCardProps = {
  itemIndex: number;
  res: any;
  productTitle: string;
  canEdit: boolean;
  editDisabled: boolean;
  onEdit: () => void;
  onDelete: () => void;
  qtyDisplay: React.ReactNode;
  /** Quoted status: show unit / extended / ETA row */
  showQuotedPricing?: boolean;
  unitPriceDisplay?: string;
  extendedPriceDisplay?: string;
  etaDisplay?: string;
};

export function QuotationItemCard({
  itemIndex,
  res,
  productTitle,
  canEdit,
  editDisabled,
  onEdit,
  onDelete,
  qtyDisplay,
  showQuotedPricing = false,
  unitPriceDisplay,
  extendedPriceDisplay,
  etaDisplay,
}: QuotationItemCardProps) {
  const sku =
    res?.sku != null && String(res.sku).trim() !== "" ? String(res.sku).trim() : "N/A";

  return (
    <article className="vq-card vq-card--panel">
      <div className="vq-card__inner">
        <div className="vq-card__top">
          <span className="vq-card__itemLabel">
            {LanguageConstants?.Item} {itemIndex}
          </span>
          {canEdit ? (
            <div className="vq-card__actions">
              <button
                type="button"
                className="vq-iconBtn vq-iconBtn--edit"
                aria-label={LanguageConstants?.EDIT ?? "Edit"}
                disabled={editDisabled}
                onClick={onEdit}
              >
                <i className="icon-edit" />
              </button>
              <button
                type="button"
                className="vq-iconBtn vq-iconBtn--delete"
                aria-label={LanguageConstants?.REMOVE ?? "Delete"}
                disabled={editDisabled}
                onClick={onDelete}
              >
                <i className="icon-delete-2" />
              </button>
            </div>
          ) : null}
        </div>
        {showQuotedPricing ? (
          <>
            <div className="vq-card__quotedRow vq-card__quotedRow--title">
              <h3 className="vq-card__title">{productTitle}</h3>
              <div className="vq-card__quotedCell--right">
                <dt className="mb-0">{LanguageConstants?.PRE_PRODUCT_PRICE ?? "Unit Price"}:</dt>
                <dd className="mb-0">{unitPriceDisplay ?? "---"}</dd>
              </div>
            </div>
            <div className="vq-card__quotedRows">
              <div className="vq-card__quotedRow">
                <div>
                  <dt>{LanguageConstants?.PARTNAMEFULL ?? "Part Number"}:</dt>
                  <dd>{res?.part_number ?? "—"}</dd>
                </div>
                <div className="vq-card__quotedCell--right">
                  <dt>{LanguageConstants?.EXTED_PRICE ?? "Extended Price"}:</dt>
                  <dd>{extendedPriceDisplay ?? "---"}</dd>
                </div>
              </div>
              <div className="vq-card__quotedRow">
                <div>
                  <dt>{LanguageConstants?.MANUAL_QUOTE_REVIEW_SERIAL_NUMBER ?? "Serial"}:</dt>
                  <dd>{res?.serial_number ?? "N/A"}</dd>
                </div>
                {/* <div className="vq-card__quotedCell--right vq-card__quotedCell--empty" aria-hidden="true" /> */}
              </div>
              <div className="vq-card__quotedRow">
                <div>
                  <dt>{LanguageConstants?.MODELNUMBER ?? "Model"}:</dt>
                  <dd>{res?.model_number ?? "N/A"}</dd>
                </div>
                {/* <div className="vq-card__quotedCell--right vq-card__quotedCell--empty" aria-hidden="true" /> */}
              </div>
              <div className="vq-card__quotedRow">
                <div>
                  <dt>{LanguageConstants?.SKU_LABEL ?? "SKU"}:</dt>
                  <dd>{sku}</dd>
                </div>
                <div className="vq-card__quotedCell--right">
                  <dt>{LanguageConstants?.VIEW_QUOTE_ETA ?? "ETA"}</dt>
                  <dd>{etaDisplay ?? "---"}</dd>
                </div>
              </div>
              <div className="vq-card__quotedRow">
                <div className="vq-card__dlRow--wide">
                  <dt>{LanguageConstants?.Description ?? "Description"}:</dt>
                  <dd>{res?.description ?? "N/A"}</dd>
                </div>
                <div className="vq-card__quotedCell--right">
                  <dt>{LanguageConstants?.QTY_SHORT ?? "Qty"}</dt>
                  <dd className="vq-card__qty">{qtyDisplay}</dd>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <h3 className="vq-card__title">{productTitle}</h3>
            <dl className="vq-card__dl">
            <div>
              <dt>{LanguageConstants?.PARTNAMEFULL ?? "Part Number"}:</dt>
              <dd>{res?.part_number ?? "—"}</dd>
            </div>
            <div>
              <dt>{LanguageConstants?.MANUAL_QUOTE_REVIEW_SERIAL_NUMBER ?? "Serial"}:</dt>
              <dd>{res?.serial_number ?? "N/A"}</dd>
            </div>
            <div>
              <dt>{LanguageConstants?.MODELNUMBER ?? "Model"}:</dt>
              <dd>{res?.model_number ?? "N/A"}</dd>
            </div>
            <div>
              <dt>{LanguageConstants?.SKU_LABEL ?? "SKU"}:</dt>
              <dd>{sku}</dd>
            </div>
            <div className="d-flex flex-column flex-sm-row gap-3 justify-content-between">
              <div className="vq-card__dlRow--wide">
                <dt>{LanguageConstants?.Description ?? "Description"}:</dt>
                <dd>{res?.description ?? "N/A"}</dd>
              </div>
              <div className="vq-card__dlRow--wide text-nowrap">
                <dt>{LanguageConstants?.QTY_SHORT ?? "Qty"}</dt>
                <dd className="vq-card__qty">{qtyDisplay}</dd>
              </div>
            </div>
          </dl>
          </>
        )}
      </div>
    </article>
  );
}
